import { useCallback, useState } from "react";
import Accordion from "../widgets/Accordion";
import { useStore } from "../../js/state/store";
import { updateBuyer } from "../../js/api/buyersApi";
import { useAutosave } from "../../js/hooks/useAutosave";
import { useGuestMode } from "../../js/hooks/useGuestMode";
import { TIPS } from "../../pages/buyer/BuyerTips";

export default function BuyerTipsPanel() {
  const { state, dispatch } = useStore();
  const { canPersist } = useGuestMode();
  const buyer = state.buyer.current;
  const [acknowledged, setAcknowledged] = useState(Boolean(buyer.preferences.tipsAcknowledged));

  const persist = useCallback(
    (next) => {
      if (!canPersist) return;
      dispatch({ type: "UPDATE_PREFERENCES", payload: { tipsAcknowledged: next } });
      if (buyer.id) {
        updateBuyer(buyer.id, { ...buyer, preferences: { ...buyer.preferences, tipsAcknowledged: next } });
      }
    },
    [buyer, canPersist, dispatch]
  );

  useAutosave(canPersist ? acknowledged : null, persist);

  return (
    <div className="sidebar-panel">
      <h3 className="sidebar-panel__title">Buyer tips</h3>
      <p className="muted sidebar-panel__lead">A short briefing. The form on the right stays where it is.</p>
      <Accordion items={TIPS} />
      <label className="checkbox-item" style={{ marginTop: "1rem" }}>
        <input
          type="checkbox"
          checked={acknowledged}
          onChange={(event) => setAcknowledged(event.target.checked)}
        />
        <span>I have read these tips and am ready to continue.</span>
      </label>
    </div>
  );
}
